export default "__VITE_ASSET__yFgumEDx__"